import { Component, OnInit } from '@angular/core';
import { DoctorInfo } from '../ha-models/doctor-info';
import { UsermanagementService } from '../../services/UserManagement.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-new-usermangement',
  templateUrl: './ha-new-usermangement.component.html',
  styleUrls: ['./ha-new-usermangement.component.css']
})

export class HaNewUsermangementComponent implements OnInit {
  doctorList: DoctorInfo[];
  tempDoctorList: DoctorInfo[];
  selectedDoctor: DoctorInfo;
  editClick: boolean = false;
  docInfo: DoctorInfo;
  showOverlayUserManagemnt: boolean;
  scrollUserLoader: boolean;
  showNoResult: boolean;
  filterValue: string = "All";
  filterValueCard: string = "CARD VIEW";
  doctPageNo: number = 1;
  memoryUsed;
  memoryUsedProfile;
  showEmptyTemplate: boolean;
  counter: number;
  element: HTMLElement;
  elementMain: HTMLElement;
  listView: boolean = false;
  totalDoctorCount: number = 0;
  doctorCurrentlySearched: string = '';
  mainViewError = new ErrorModel();

  filterType:[{id:1,name:'All'},{id:2,name:'Active'},{id:3,name:'Blocked'}];

  constructor(private _service: UsermanagementService) {

  }

  ngOnInit() {
    this.counter = 1;
    this.showNoResult = false;
    this.getDoctors(this.doctPageNo, '');
  }

  deviceEdit() {
    this.editClick = true;
  }

  updateDeviceName(deviceName, eaHospId, id) {
    if (deviceName == "" || deviceName == null || deviceName == undefined) {
      AlertMessages.Show("Warning", "Device Name Cannot be Empty!!!", AlertType.Warning);
    } else {
      if (this.docInfo.systemName.toLowerCase() == deviceName.toLowerCase()) {
        this.editClick = false;
      } else {
        this._service.updateDeviceNameOfUser(deviceName, eaHospId).subscribe(
        (data) => {

          if (data == true) {
            this.docInfo.systemName = deviceName;
            let indexMain = this.doctorList.findIndex(ij => ij.id == id);
            this.doctorList[indexMain].systemName = deviceName;
            let indexTemp = this.tempDoctorList.findIndex(ik => ik.id == id);
            this.tempDoctorList[indexTemp].systemName = deviceName;
            this.editClick = false;
            AlertMessages.Show("Success", "Device Name Updated Successfully!!", AlertType.Success);
          }
        },
        (error) => {
          AlertMessages.Show('Failed','Could not update!',AlertType.Error);
        });
      }
    }
  }

  copyLicense(licNo) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '-120%';
    selBox.style.top = '-50%';
    selBox.style.opacity = '0';
    selBox.value = licNo;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy', false, licNo);
    AlertMessages.Show("Copied", licNo + " Copied", AlertType.Success);
  }

  getDoctors(pageNo, text) {
    this.showOverlayUserManagemnt = true;
    this.mainViewError.display = false;
    this.doctPageNo = 1;
    this._service.getUsers(pageNo, text).subscribe(
    (data) => {
      this.doctorList = data["Data"] as DoctorInfo[];
      this.tempDoctorList = data["Data"] as DoctorInfo[];
      this.totalDoctorCount = data["Count"];
      this.showOverlayUserManagemnt = false;
      this.scrollUserLoader = false;
      if (this.counter == 1) {
        this.counter = this.counter + 1;
        this.doctorList.length < 1 ? this.showEmptyTemplate = true : this.showEmptyTemplate = false;
      } else {
        this.showEmptyTemplate = false;
        this.doctorList.length == 0 ? this.showNoResult = true : this.showNoResult = false;

      }

    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayUserManagemnt = false;
    this.scrollUserLoader = false;

    });
  }


  filterList(val) {
    this.scrollUserLoader = true;

    switch(val) {
      case '1':
        this.callForAction('All',val);
        break;
      case '2':
        this.callForAction('Active',val);
        break;
      case '3':
        this.callForAction('Blocked',val);
        break;
      default:
        alert("ERROR: Out of Cases...");
    }

    this.doctorList.length == 0 ? this.showNoResult = true : this.showNoResult = false;

  }

  callForAction(text,val) {
    this.showEmptyTemplate = false;
    this.filterValue = text;

    switch(val) {
      case '1':
        this.doctorList = this.tempDoctorList;
        break;

      case '2':
      this.doctorList = this.tempDoctorList.filter(doctor => doctor.isLock == false);
        break;

      case '3':
      this.doctorList = this.tempDoctorList.filter(doctor => doctor.isLock == true);
        break;

      default:
        alert('case not included');

    }
    this.scrollUserLoader = false;
  }


  viewUser(id, EaHosId) {
    $("#moreDetailModal").modal('show');
    this.memoryUsed = 0;
    this.selectedDoctor = this.doctorList.filter(doctor => doctor.id == id)[0];
  }

  stopProp(event) {
    event.stopPropagation();
  }

  openNav(id) {
    this.memoryUsedProfile = 0;
    this.editClick = false;
    this.docInfo = new DoctorInfo();

    this.resetBorder();
    let index1 = this.doctorList.findIndex(a => a.id == id);
    this.doctorList[index1].border = "2px solid #0969c9";
    this.doctorList[index1].borderBottom = "2px solid #0969c9";
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = "0px";
    this.element.style.opacity = "1";
    this.elementMain = document.getElementById('userlistscroll') as HTMLElement;
    this.elementMain.style.width = "70%";
    this.docInfo = this.doctorList.filter(doctor => doctor.id == id)[0];
  }

  closeNav() {

    this.resetBorder();
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = "-105%";
    this.element.style.opacity = "0";
    this.editClick = false;
    this.elementMain = document.getElementById('userlistscroll') as HTMLElement;
    this.elementMain.style.width = "100%";
  }

  resetBorder() {
    for (let user of this.doctorList) {
      user.border = "";
      user.borderBottom = "";
    }
  }

  getDoctorsOnScroll(text) {
    this.scrollUserLoader = true;
    this.doctPageNo = this.doctPageNo + 1;
    this._service.getUsers(this.doctPageNo, text).subscribe(
    (data) => {
      let admins: DoctorInfo[] = data["Data"];
      if (admins != undefined) {
        admins.forEach((i) => {
          this.doctorList.push(i);
        })
      }
      this.scrollUserLoader = false;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load', AlertType.Error);
    }).add(() => {
      this.scrollUserLoader = false;
    });
  }

  getDoctorsOnSearch(text: string) {
    this.doctorCurrentlySearched = text;
    this.doctPageNo = 1;
    this.scrollUserLoader = true;
    this.getDoctors(this.doctPageNo, text.trim());
  }


  blockActivate(saHospId, index, event) {
    this.scrollUserLoader = true;
    if (event.target.checked == true) {
      this.changeUserStatus(saHospId, index, true);
    } else {
      this.changeUserStatus(saHospId, index, false);
    }
  }

  changeUserStatus(saHospId, index, type) {
    this._service.blockActiveUser(saHospId).subscribe(
    (message) => {

      this.doctorList[index].isLock = type;
      let name = this.doctorList[index].name;
      this.scrollUserLoader = false;
      if (type) {
        AlertMessages.Show('Blocked', name + ' is Blocked', AlertType.Error);
      } else {
        AlertMessages.Show('Activated', name + ' is Activated', AlertType.Success);
      }
    },
    (error) => {
      AlertMessages.Show('Failed','Could not update !', AlertType.Error);
    });
  }
}


